
import * as THREE from 'three';
import * as marietta from '../../..';
import { mm2D, pix2D, Unit } from '../../graphicLibs/util/unit';
import { BUILDING_TYPE_MANSION, BUILDING_TYPE_HOUSE } from '../../../webcad/Constants';
import { FurnitureInfo, FurnitureType } from '../FurnitureInfo';

export class AddFurniture2D {

    constructor(private buildingType: number, private furnitureInfo: FurnitureType[][]) {
        ;
    }

    /**
     * 家具・住設の表示
     * */
    public execute(floor: number): void {

        if (this.furnitureInfo[floor-1].length == 0) return;

        const infoCollectionsFur: {}[] = [];
        const infoCollectionsEqu: {}[] = [];
        const center2D = new THREE.Vector2(marietta.webcad.WebCADGlobal.LAYER_SIZE_W/2, marietta.webcad.WebCADGlobal.LAYER_SIZE_H/2);
        this.furnitureInfo[floor-1].forEach((obj: FurnitureType) => {
            /** itemIdの取得 */
            let itemId = this.getItemId(Object.keys(obj.category)[0]);
            /** typeの取得 */
            const type = this.getItemType(Object.keys(obj.category)[0]);
            /** 階段データは無視 */
            if (type == 'stairs') return;

            const info: any = {};
            info.f = floor;
            info.is_reverse = false;
            info.idthreed = '';
            const pix = <pix2D>new THREE.Vector2(center2D.x, center2D.y);
            if (this.buildingType == BUILDING_TYPE_MANSION) {
                /** マンション **/
                const posMMData = <mm2D>new THREE.Vector2((obj.position.x) * 1000, (obj.position.z) * 1000);
                info.x = Unit.convertPixtoMm(pix).x + posMMData.x;
                info.y = Unit.convertPixtoMm(pix).y - posMMData.y;
            } else {
                /** 戸建て **/
                const posMMData = <mm2D>new THREE.Vector2((obj.position.x) * 1000, (obj.position.z) * 1000);
                info.x = pix.x + Unit.convertMmtoPix(posMMData).x;
                info.y = pix.y - Unit.convertMmtoPix(posMMData).y;
            }
            info.id = itemId;
            info.guid = marietta.webcad.WebCADGlobal.getGuid();
            info.rotation = FurnitureInfo.unit45deg(obj.rotation);

            info.width = obj.width;
            info.depth = obj.depth;
            info.height = Math.round(obj.height);
            
            if (type == 'furniture') infoCollectionsFur.push(info);
            if (type == 'equipment') infoCollectionsEqu.push(info);
        });

        marietta.webcad.util.WebcadJSONParser.reproduceCommonItem(infoCollectionsFur, 'furniture');
        marietta.webcad.util.WebcadJSONParser.reproduceCommonItem(infoCollectionsEqu, 'equipment');

    }

    /** itemIdの取得 */
    private getItemId = (category: string): string => {
        switch (category) {
            case 'dishwasher':
            case 'fireplace':
            case 'oven':
            case 'storage':
            case 'stove':
            case 'washerDryer':
                return 'fur28_02';
            case 'bathtub':
                return 'equ07_01';
            case 'bed':
                return 'fur02_01';
            case 'chair':
                return 'fur08_01';
            case 'refrigerator':
                return 'fur12_01';
            case 'sink':
                return 'equ02_01';
            case 'sofa':
                return 'fur03_08';
            case 'stairs':
                return '';
            case 'table':
                return 'fur19_01';
            case 'television':
                return 'fur04_07';
            case 'toilet':
                return 'equ10_01';
            default:
                return 'fur28_02';
        }
    }

    /** typeの取得 */
    private getItemType = (category: string): string => {
        switch (category) {
            case 'fireplace':
            case 'washerDryer':
            case 'bathtub':
            case 'sink':
            case 'toilet':
                return 'equipment';
            case 'dishwasher':
            case 'oven':
            case 'storage':
            case 'stove':
            case 'bed':
            case 'chair':
            case 'refrigerator':
            case 'sofa':
            case 'table':
            case 'television':
                return 'furniture';
            case 'stairs':
                return 'stairs';
            default:
                return '';
        }
    }

}